<script>
export default {
  props: {
    value: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      modalIsOpen: false,
      currentSlide: this.value,
      maxSlides: 10,
    };
  },
  watch: {
    value(val) {
      this.currentSlide = val;
    },
  },
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
    language() {
      return this.authStore?.feature_options?.language?.language_option === 'en' ? '-en' : '';
    },
  },
  methods: {
    prev() {
      this.currentSlide = (
        this.currentSlide <= 1 ? 1 : (this.currentSlide - 1)
      );
    },
    next() {
      this.currentSlide = (
        this.currentSlide >= this.maxSlides ? this.maxSlides : (this.currentSlide + 1)
      );
    },
    selectSlide() {
      this.modalIsOpen = false;
      this.$emit('input', this.currentSlide);
    },
  },
};
</script>

<template>
  <div>
    <b-modal v-if="modalIsOpen" :active.sync="modalIsOpen">
      <div class="box">
        <figure class="image">
          <img :src="require(`@app/assets/img/certificates/${currentSlide}${language}.png`)" />
        </figure>
        <div class="is-flex is-align-items-center is-justify-content-flex-end mt-5">
          <p class="mr-2">
            ({{ currentSlide }} / {{ maxSlides }})
          </p>
          <b-button
            class="mr-2"
            icon-left="chevron-left"
            :disabled="currentSlide <= 1"
            @click="prev"
          />
          <b-button
            class="mr-2"
            icon-left="chevron-right"
            :disabled="currentSlide >= maxSlides"
            @click="next"
          />
          <b-button type="is-primary" @click="selectSlide">
            Sélectionner ce certificat
          </b-button>
        </div>
      </div>
    </b-modal>
    <p class="mt-3">
      <b-button expanded @click="modalIsOpen = true">
        Choisir un certificat <AppFeatureBadge class="ml-3" />
      </b-button>
    </p>
  </div>
</template>
